// webpack entry point to load all required JavaScript files
import './legacy/loader';
import { initLegacyApplication } from './legacy/index';

const { rise, app } = window as any;

initLegacyApplication(rise, app);
